



















































































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import Vuelidate from 'vuelidate';
import vSelect from 'vue-select';
import { required, maxLength } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import OrgPicker from '@/components/orgPicker.vue';
import Toast from '@/components/display/toast.vue';
import SiteLookup from '@/components/site-lookup.vue';
// import VueGoogleAutocomplete from 'vue-google-autocomplete'

import { Site, SitesApi, Address, ThingGroup, ThingGroupsApi } from '../../../api';

@Component({
	components: {
		secondaryNav,
		vSelect,
		OrgPicker,
		Toast,
		SiteLookup,
	},
	validations: {
		form: {
			name: { required, maxLength: maxLength(30) },
			org: { required },
			site1: { lat: { required }, lng: { required } },
		},
	},
	mixins: [validationMixin],
})
export default class SiteUpdate extends Vue {
	public form = {
		name: '',
		org: {},
		site1: { address: '', lat: '', lng: '', region: '' },
		thingGroupName: '',
	};
	public markers = [];
	public place = null;
	public region: any = null;
	public site: Site | null = null;
	public loading = true;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;

	public thingGroupList = [];
	public thingGroups = [];
	public transceiver: any = null;
	private api: SitesApi;

	constructor() {
		super();
		this.api = new SitesApi();
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		const { siteId } = this.$route.params;
		const site: Site = this.form;
		site.latitude = this.form.site1.lat;
		site.longitude = this.form.site1.lng;
		site.orgId = this.form.org.id;
		site.thingGroupName = this.form.thingGroupName;
		try {
			const response = await new SitesApi().updateSite(parseInt(siteId, 10), { data: site });
		} catch (e) {
			const error = e.response.data.errors.name[0];
			new Toast().makeToast(error, 'Error Updating Site', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast('Site Updated', 'Successfully updated', 'success');

		setTimeout(() => {
			this.submitStatus = 'OK';
			this.$router.push({ name: 'sites.view', params: { siteId } });
		}, 1000);
	}

	public async load() {
		const { siteId } = this.$route.params;
		this.loading = true;

		try {
			const response = await new ThingGroupsApi().getThingGroups({
				params: { include: 'transceivers,transceivers.site', perPage: 250 },
			});
			const data = response.data.data;
			this.thingGroups = data.sort((a, b) => (a.name > b.name ? 1 : -1));

			const groups = [];
			this.thingGroups.forEach(group => {
				groups.push(group.name);
			});
			this.thingGroupList = groups;
		} catch (e) {
			console.log(e);
		}

		try {
			const response = await this.api.getSiteById(parseInt(siteId, 10), {
				params: { include: 'address,org,transceivers' },
			});
			const site: Site = response.data;
			const address: Address = site.address;

			this.form.org = site.org;
			this.form.name = site.name;
			this.form.thingGroupName = site.thingGroupName;
			this.form.site1.address = address.fullAdr || '';
			this.form.site1.lat = site.latitude;
			this.form.site1.lng = site.longitude;
			this.site = site;

			this.transceiver = this.site.transceivers[0];
			this.form.thingGroupName = this.transceiver.thingGroupName;
		} catch (e) {
			this.site = null;
		} finally {
			this.loading = false;
		}
	}

	public created() {
		this.load();
	}
}
